import {inject, injectable} from 'inversify';
import { action, computed, observable } from 'mobx';
import { CardApi } from '../../api/CardApi';
import Helpers from '../../helpers/Helpers';
import { EvaluationMark, VocabularyCardModel } from '../../interfaces/models/CardModel';
import Logger from '../../utils/Logger';
import { CardStore } from '../CardStore';
import { UserStore } from '../UserStore';
import { BaseCardStore } from './BaseCardStore';
import {CardSourceSymbol, ICardSourceAdapter} from "../adapters/ICardSourceAdapter";
import {CourseStore} from "../CourseStore";

export enum VocabularyCardStep {
    PREVIEW, ANSWER
}

@injectable()
export class VocabularyCardStore extends BaseCardStore<VocabularyCardModel> {

    @observable step = VocabularyCardStep.PREVIEW;
    @observable testOdd = true;

    @computed get sourceWord() {
        return this.card.inverted ?
            this.card.word_translation.translation_word_lemma :
            this.card.word_translation.source_word_lemma;
    }

    @computed get translationWord() {
        return !this.card.inverted ?
            this.card.word_translation.translation_word_lemma :
            this.card.word_translation.source_word_lemma;
    }

    constructor(
        protected cardStore: CardStore,
        // private cardApi: CardApi,
        private userStore: UserStore,
        private courseStore: CourseStore,
        @inject(CardSourceSymbol) private cardSource: ICardSourceAdapter,
    ) {
        super(cardStore);
    }

    /**
     * Self evaluation for the current card
     */
    @action.bound async evaluate(mark: EvaluationMark) {
        if (!this.cardStore.isBufferLoaded) {
            return false;
        }

        try {
            const currentId = this.card.id;
            const isChangeMode = this.cardStore.isChangeMode;

            this.cardStore.isChangeMode = false;
            this.cardStore.isLoading = true;
            await this.cardStore.loadCard();

            // await this.cardApi.evaluate(currentId, this.card.id, mark, this.cardStore.isChangeMode);
            await this.cardSource.evaluate(currentId, this.courseStore.currentCourse.id, this.card?.id, mark, isChangeMode, null);

            if (isChangeMode) {
                return this.cardStore._disableChangingMode(true);
            } else {
                if (this.card?.is_new) {
                    this.userStore.progress.offset++;
                }

                return this.cardStore.loadBuffer();
            }
        } catch (e) {
            Logger.error(e);
        } finally {
            this.cardStore.isLoading = false;
        }
    }

}
